module.exports = "<example-shell\n  exampleId=\"empty\" [title]=\"title\" [summary]=\"summary\" [dataSnippet]=\"dataSnippet\" [events]=\"events\" (clear)=\"clearEvents()\">\n  <stackline-data-table\n    title=\"Empty project list\"\n    [columns]=\"orderColumns\"\n    [data]=\"emptyRows\"\n    noDataText=\"No projects were found\">\n  </stackline-data-table>\n</example-shell>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/examples/empty/empty.component.html
// module id = ./src/app/examples/empty/empty.component.html
// module chunks = main